/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IHosports2ColumnBannersViewProps } from './hosports-2-column-banners';

export default (props: IHosports2ColumnBannersViewProps) => {
    return (
        <h2>{'hosports-two-column-banners-view'}</h2>
    );
};
